import React from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import './index.css';
import Main from './Main';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

if (container !== null) {
  createRoot(container).render(
    process.env.NODE_ENV === 'development' ? (
      <React.StrictMode>
        <Main />
      </React.StrictMode>
    ) : (
      <Main />
    )
  );
}

reportWebVitals();
